var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.028,
    height: 21.317,
    viewBox: "0 0 70.028 21.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c,.d,.e{fill-rule:evenodd;}.b{fill:url(#a);}.c{fill:url(#b);}.d{fill:url(#c);}.e{fill:url(#d);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.808,
    y1: 0.596,
    x2: 0.599,
    y2: 0.082,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef2131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fecf2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.588,
    x2: 0.092,
    y2: 0.941,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbc52c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#f87130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#ef52e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661eec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.206,
    y1: 0.41,
    x2: 0.406,
    y2: 0.913,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78f6d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#77d1f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#70a4f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661eec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.424,
    y1: 1,
    x2: 0.916,
    y2: 0.063,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#536eed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#54c3ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#64d769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fecf2c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.914 4.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.651,1.928a1.767,1.767,0,0,1,.136-.692,1.809,1.809,0,0,1,.369-.563A1.721,1.721,0,0,1,40.7.294a1.641,1.641,0,0,1,.672-.138,1.687,1.687,0,0,1,.681.138,1.734,1.734,0,0,1,.553.379,1.787,1.787,0,0,1,.371.563,1.767,1.767,0,0,1,.136.692,1.767,1.767,0,0,1-.136.692,1.787,1.787,0,0,1-.371.563,1.734,1.734,0,0,1-.553.379,1.687,1.687,0,0,1-.681.138,1.641,1.641,0,0,1-.672-.138,1.721,1.721,0,0,1-.546-.379,1.809,1.809,0,0,1-.369-.563A1.767,1.767,0,0,1,39.651,1.928Zm.354,0a1.524,1.524,0,0,0,.1.568,1.416,1.416,0,0,0,.289.457,1.353,1.353,0,0,0,.434.306,1.309,1.309,0,0,0,.541.112,1.338,1.338,0,0,0,.548-.112,1.374,1.374,0,0,0,.439-.306,1.427,1.427,0,0,0,.293-.457,1.493,1.493,0,0,0,.107-.568,1.493,1.493,0,0,0-.107-.568A1.427,1.427,0,0,0,42.36.9,1.374,1.374,0,0,0,41.921.6a1.338,1.338,0,0,0-.548-.112A1.309,1.309,0,0,0,40.832.6,1.353,1.353,0,0,0,40.4.9a1.416,1.416,0,0,0-.289.457A1.524,1.524,0,0,0,40.005,1.928Zm.776-.762a.142.142,0,0,1,.16-.16h.548a.573.573,0,0,1,.417.151.542.542,0,0,1,.155.408.52.52,0,0,1-.112.333.474.474,0,0,1-.107.1.374.374,0,0,1-.116.053v.01a.145.145,0,0,1,.015.019.107.107,0,0,1,.019.032.355.355,0,0,0,.029.051l.252.491a.15.15,0,0,1,.019.134.106.106,0,0,1-.107.051H41.9a.191.191,0,0,1-.189-.117l-.281-.592h-.3v.554a.135.135,0,0,1-.15.155h-.044a.135.135,0,0,1-.15-.155Zm.635.709a.285.285,0,0,0,.218-.083.32.32,0,0,0,.078-.228.3.3,0,0,0-.078-.219.288.288,0,0,0-.213-.078h-.3v.607ZM27.28,3.036a4.071,4.071,0,0,1,1.395.21,6.728,6.728,0,0,1,.895.388.567.567,0,0,1,.323.388.822.822,0,0,1-.081.517l-.161.291a.565.565,0,0,1-.371.339.9.9,0,0,1-.532-.081q-.274-.129-.661-.266a2.7,2.7,0,0,0-.9-.137,1.386,1.386,0,0,0-.822.21.693.693,0,0,0-.29.6.643.643,0,0,0,.3.549,3.109,3.109,0,0,0,.758.371l.984.347a4.887,4.887,0,0,1,.984.476,2.5,2.5,0,0,1,.758.743,2.042,2.042,0,0,1,.3,1.147,2.33,2.33,0,0,1-.218,1.009,2.307,2.307,0,0,1-.629.8,3.067,3.067,0,0,1-.992.533,4.057,4.057,0,0,1-1.29.194,4.319,4.319,0,0,1-1.685-.291,6.01,6.01,0,0,1-1.056-.549.559.559,0,0,1-.306-.4.765.765,0,0,1,.145-.517l.194-.291a.6.6,0,0,1,.4-.291.881.881,0,0,1,.524.129q.29.161.75.363a2.691,2.691,0,0,0,1.088.2,1.385,1.385,0,0,0,.839-.226.723.723,0,0,0,.306-.614.623.623,0,0,0-.3-.541,3.554,3.554,0,0,0-.758-.371L26.175,7.9a5.222,5.222,0,0,1-.984-.484,2.5,2.5,0,0,1-.758-.743,2.073,2.073,0,0,1-.3-1.163,2.2,2.2,0,0,1,.927-1.841,3.176,3.176,0,0,1,1-.468A4.465,4.465,0,0,1,27.28,3.036Zm-23.969,0a4.071,4.071,0,0,1,1.395.21,6.728,6.728,0,0,1,.895.388.567.567,0,0,1,.323.388.822.822,0,0,1-.081.517l-.161.291a.566.566,0,0,1-.371.339.9.9,0,0,1-.532-.081Q4.5,4.957,4.117,4.82a2.7,2.7,0,0,0-.9-.137,1.386,1.386,0,0,0-.822.21.693.693,0,0,0-.29.6.643.643,0,0,0,.3.549,3.109,3.109,0,0,0,.758.371l.984.347a4.887,4.887,0,0,1,.984.476,2.5,2.5,0,0,1,.758.743,2.042,2.042,0,0,1,.3,1.147,2.33,2.33,0,0,1-.218,1.009,2.307,2.307,0,0,1-.629.8,3.067,3.067,0,0,1-.992.533,4.057,4.057,0,0,1-1.29.194,4.319,4.319,0,0,1-1.685-.291,6.01,6.01,0,0,1-1.056-.549.559.559,0,0,1-.306-.4A.765.765,0,0,1,.15,9.9l.194-.291a.6.6,0,0,1,.4-.291.881.881,0,0,1,.524.129q.29.161.75.363a2.691,2.691,0,0,0,1.088.2,1.385,1.385,0,0,0,.839-.226.723.723,0,0,0,.306-.614.623.623,0,0,0-.3-.541A3.554,3.554,0,0,0,3.19,8.26L2.206,7.9a5.222,5.222,0,0,1-.984-.484,2.5,2.5,0,0,1-.758-.743,2.073,2.073,0,0,1-.3-1.163,2.2,2.2,0,0,1,.927-1.841,3.176,3.176,0,0,1,1-.468A4.465,4.465,0,0,1,3.311,3.036ZM32.713,0a.6.6,0,0,1,.677.678V4q0,.161-.008.283t-.024.218a1.4,1.4,0,0,0-.016.194h.032a2.735,2.735,0,0,1,.411-.589,3.259,3.259,0,0,1,.629-.541,3.22,3.22,0,0,1,.822-.388,3.272,3.272,0,0,1,.992-.145,2.884,2.884,0,0,1,2.12.743,3.257,3.257,0,0,1,.75,2.39v4.618a.6.6,0,0,1-.677.678h-.693a.6.6,0,0,1-.677-.678v-4.2a2.488,2.488,0,0,0-.258-1.219,1.078,1.078,0,0,0-1.032-.46,2.251,2.251,0,0,0-.976.21,2.2,2.2,0,0,0-.75.573,2.632,2.632,0,0,0-.476.864,3.356,3.356,0,0,0-.169,1.082v3.149a.6.6,0,0,1-.677.678H32.02a.6.6,0,0,1-.677-.678V.678A.6.6,0,0,1,32.02,0ZM22,3.23a.592.592,0,0,1,.661.678v6.879a.592.592,0,0,1-.661.678h-.71a.592.592,0,0,1-.661-.678V3.908a.592.592,0,0,1,.661-.678Zm-13.682,0a.664.664,0,0,1,.726.6l1.322,4.812q.032.178.056.323t.056.275q.032.145.048.275h.032q.016-.129.048-.275.032-.129.056-.275a3.309,3.309,0,0,1,.073-.323l1.387-4.812a.669.669,0,0,1,.742-.581h.613a.7.7,0,0,1,.742.581L15.59,8.639a3.308,3.308,0,0,1,.073.323q.024.145.056.275.032.145.048.275H15.8q.016-.129.048-.275.032-.129.056-.275a3.309,3.309,0,0,1,.073-.323l1.306-4.812a.7.7,0,0,1,.742-.6h.742a.583.583,0,0,1,.516.21.628.628,0,0,1,.048.549L17.219,10.9a.716.716,0,0,1-.758.565H15.38a.7.7,0,0,1-.758-.581L13.381,6.766q-.048-.161-.081-.323t-.064-.291q-.032-.145-.048-.275h-.032q-.032.129-.065.275-.032.129-.065.291t-.081.323L11.7,10.884a.7.7,0,0,1-.742.581H9.849a.706.706,0,0,1-.742-.565L6.979,3.989a.61.61,0,0,1,.056-.549.587.587,0,0,1,.508-.21Z",
    transform: "translate(0 0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.063 2.495)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,17.784A10.66,10.66,0,0,0,11.447,0l-3,3.572A8.325,8.325,0,0,1,9.475,15.3,8.461,8.461,0,0,1,0,17.784",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,43.676a10.665,10.665,0,0,0,12.76-2.77,10.73,10.73,0,0,0,1.033-1.463A9.338,9.338,0,0,0,8.45,29.465,8.324,8.324,0,0,1,9.475,41.194,8.461,8.461,0,0,1,0,43.676",
    transform: "translate(0 -25.893)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M15.254,1.038A10.66,10.66,0,0,0,3.807,18.821l3-3.572A8.325,8.325,0,0,1,5.779,3.52a8.461,8.461,0,0,1,9.475-2.482",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M24.984,1.038A10.675,10.675,0,0,0,11.191,5.27a9.338,9.338,0,0,0,5.343,9.979A8.324,8.324,0,0,1,15.51,3.52a8.461,8.461,0,0,1,9.475-2.482",
    transform: "translate(-9.73 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwish);
export default __webpack_public_path__ + "static/media/swish.0730043b95d98cfbdf857288d2599e3c.svg";
export { ForwardRef as ReactComponent };